import React from 'react'
import { components, type IndicatorProps } from 'react-select'
import { SearchIcon } from '@instacart/ids-core'
import { type GroupedOptions } from 'domains/account-management/components/retailer-location-store-group-select/utils/types'

export const DropdownIndicator = (props: IndicatorProps<GroupedOptions>) => (
  <components.DropdownIndicator {...props}>
    <SearchIcon size={20} color="systemGrayscale70" />
  </components.DropdownIndicator>
)
